import { render, staticRenderFns } from "./AddConclusion.vue?vue&type=template&id=cdc9799c&scoped=true"
import script from "./AddConclusion.vue?vue&type=script&lang=js"
export * from "./AddConclusion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc9799c",
  null
  
)

export default component.exports